import { apiClient } from '../lib/api/client'

export interface OnwerFormData {
  email: string
  password?: string
  name: string
  phone?: string
}

export class DropdownsRepository<T> {
  private functionName = 'dropdown-options'

  async getAll(entity: string): Promise<T[]> {
    return apiClient.invoke<T[]>(`${this.functionName}?entity=${entity}`, {
      method: 'GET',
    })
  }
}
